<div class="containertenantmanagement">
  <div class="col-md-12 px-0" style="margin-top: 5%;">
    <div class="row documentForm">
      <button role="button" class="schBtn" (click)="CreateNewtenant()">Create</button>
    </div>
    <div class="row position-relative">
      <div class="col-md-12 no-border" style="border: solid 2px #eee;">
        <ag-grid-angular [defaultColDef]="defaultColDef" style="height: 26rem;margin-left: -1%;"
          class="ag-theme-alpine col-md-12" [rowData]="rowData" [columnDefs]="columnDefs"
          [overlayLoadingTemplate]="overlayLoadingTemplate" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
          [rowSelection]="rowSelection" [enableCellTextSelection]="'true'" (gridReady)="onGridReady($event)"
          [rowHeight]="rowHeight" [paginationAutoPageSize]="true" [pagination]="true"
          [frameworkComponents]="frameworkComponents" (cellClicked)="onCellClicked($event)"
          [tooltipShowDelay]="tooltipShowDelay" [suppressRowHoverHighlight]="true" [animateRows]="true">
        </ag-grid-angular>
      </div>
    </div>
  </div>

</div>
